export enum PensionSubSteps {
  MAIN = 'main',
  PENSION = 'pension',
}
